import React from 'react'
import { ContentBlock } from 'components/ContentBlock'
import CashRegisterList from 'components/CashRegisterTree'

const CashRegisters = ({ data, mutations: { updateItem } }) => (
	<ContentBlock>
		<CashRegisterList
			activeNodesArr={data.cashRegisterId}
			onChange={cashRegisterId => updateItem({ cashRegisterId })}
			withContext
		/>
	</ContentBlock>
)

export default CashRegisters
